import { Button } from '@/global/components/Button'
import { cn } from '@/lib/utils'
import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface Props {
    titulo: React.ReactNode
    /** Tooltip do botão `+`. */
    tituloAdicionar: string
    /** Sem ele o `+` não aparece — falta de permissão ou tela só de leitura. */
    onAdicionar?: () => void
    /** Ações extras no cabeçalho, antes do `+`. */
    acoes?: ReactNode
    children: ReactNode
}

/** Moldura das listas de associação: cabeçalho com título e `+`, lista embaixo. */
export function CardAssociacoes({
    titulo,
    tituloAdicionar,
    onAdicionar,
    acoes,
    children,
}: Props) {
    return (
        <div
            className={cn(
                'size-full flex flex-col rounded-lg',
                'overflow-hidden border shadow-sm',
            )}
        >
            <div className="inline-flex justify-between items-center gap-1 w-full p-2 border-b bg-card">
                {typeof titulo === 'string' ? (
                    <span className="text-lg font-semibold truncate">
                        {titulo}
                    </span>
                ) : (
                    titulo
                )}
                <div className="inline-flex items-center gap-2">
                    {acoes}
                    {onAdicionar && (
                        <Button
                            onClick={onAdicionar}
                            className="size-10"
                            title={tituloAdicionar}
                        >
                            <PlusIcon className="size-8 stroke-3" />
                        </Button>
                    )}
                </div>
            </div>
            {children}
        </div>
    )
}
